import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { getDashboardStats, getTestsByDate, getPopularTests, getDemographics } from "../services/Model";
import StatsCards from "../components/StatsCards";
import TestsChart from "../components/TestsChart";
import PopularTestsChart from "../components/PopularTestsChart";
import DemographicsChart from "../components/DemographicsChart";

const Dashboard = () => {
  const [overview, setOverview] = useState({});
  const [testsData, setTestsData] = useState([]);
  const [popularTests, setPopularTests] = useState([]);
  const [demographics, setDemographics] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [overviewRes, testsRes, popularRes, demoRes] = await Promise.all([
        getDashboardStats(),
        getTestsByDate(30),
        getPopularTests(),
        getDemographics()
      ]);

      setOverview(overviewRes.data);
      setTestsData(testsRes.data);
      setPopularTests(popularRes.data);
      setDemographics(demoRes.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
      <Helmet>
        <title>FOH Lab - Dashboard</title>
      </Helmet>
      
      <div className="row mb-4">
        <div className="col-12">
          <h2 className="fw-bold">FOH Lab Dashboard</h2>
          <p className="text-muted">Overview of laboratory operations and statistics</p>
        </div>
      </div>

      <StatsCards overview={overview} />

      <div className="row mb-4">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Tests Over Time (Last 30 Days)</h5>
            </div>
            <div className="card-body">
              <TestsChart data={testsData} />
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Gender Distribution</h5>
            </div>
            <div className="card-body">
              <DemographicsChart data={demographics.genderDistribution || []} />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Popular Tests</h5>
            </div>
            <div className="card-body">
              <PopularTestsChart data={popularTests} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;